/* SHUNYA WATCHES — Shopify theme JS (uses the real Shopify Cart AJAX API) */
(function () {
  "use strict";

  var routes = (window.SHUNYA && window.SHUNYA.routes) || {
    cartAddUrl: "/cart/add.js",
    cartChangeUrl: "/cart/change.js",
    cartUrl: "/cart",
    cartJsonUrl: "/cart.js"
  };

  function fmtMoney(cents) {
    return "₹" + (cents / 100).toLocaleString("en-IN", { maximumFractionDigits: 0 });
  }

  function sizedImage(url, width) {
    if (!url) return url;
    return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + width;
  }

  /* TOAST */
  var toastTimer;
  function showToast(msg) {
    var t = document.getElementById("toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2200);
  }

  /* HEADER SEARCH */
  var navSearch = document.getElementById("navSearch");
  var searchInput = document.getElementById("searchInput");
  var searchToggle = document.getElementById("searchToggle");
  function openSearch() {
    if (!navSearch) return;
    navSearch.classList.add("active");
    searchInput.focus();
  }
  function closeSearch() {
    if (!navSearch) return;
    navSearch.classList.remove("active");
  }
  if (searchToggle) {
    searchToggle.addEventListener("click", function () {
      if (navSearch.classList.contains("active") && searchInput.value.trim() === "") {
        closeSearch();
      } else if (navSearch.classList.contains("active")) {
        searchInput.closest("form").submit();
      } else {
        openSearch();
      }
    });
  }
  document.addEventListener("click", function (e) {
    if (navSearch && navSearch.classList.contains("active") && !navSearch.contains(e.target)) {
      if (searchInput.value.trim() === "") closeSearch();
    }
  });

  /* MOBILE MENU */
  var menuToggle = document.getElementById("menuToggle");
  var mobileNav = document.getElementById("mobileNav");
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener("click", function () {
      menuToggle.classList.toggle("active");
      mobileNav.classList.toggle("open");
    });
    mobileNav.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        menuToggle.classList.remove("active");
        mobileNav.classList.remove("open");
      });
    });
  }

  /* BACK TO TOP */
  var backToTop = document.getElementById("backToTop");
  if (backToTop) {
    window.addEventListener("scroll", function () {
      backToTop.classList.toggle("show", window.scrollY > 500);
    });
    backToTop.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  /* PRODUCT SLIDER (home page featured products) */
  var grid = document.getElementById("productGrid");
  var prevBtn = document.getElementById("prevBtn");
  var nextBtn = document.getElementById("nextBtn");
  if (grid && prevBtn && nextBtn) {
    function updateArrowState() {
      var maxScroll = grid.scrollWidth - grid.clientWidth;
      prevBtn.disabled = grid.scrollLeft <= 4;
      nextBtn.disabled = grid.scrollLeft >= maxScroll - 4;
    }
    prevBtn.addEventListener("click", function () { grid.scrollBy({ left: -grid.clientWidth, behavior: "smooth" }); });
    nextBtn.addEventListener("click", function () { grid.scrollBy({ left: grid.clientWidth, behavior: "smooth" }); });
    grid.addEventListener("scroll", function () { window.requestAnimationFrame(updateArrowState); });
    window.addEventListener("resize", updateArrowState);
    updateArrowState();
  }

  /* CART DRAWER (real Shopify Cart AJAX API) */
  var overlay = document.getElementById("overlay");
  var cartDrawer = document.getElementById("cartDrawer");
  var cartCountEl = document.getElementById("cartCount");

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add("open");
    overlay.classList.add("open");
    refreshCartDrawer();
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove("open");
    overlay.classList.remove("open");
  }
  var cartToggle = document.getElementById("cartToggle");
  var cartClose = document.getElementById("cartClose");
  if (cartToggle) cartToggle.addEventListener("click", function (e) { e.preventDefault(); openCartDrawer(); });
  if (cartClose) cartClose.addEventListener("click", closeCartDrawer);
  if (overlay) overlay.addEventListener("click", closeCartDrawer);

  function renderCartDrawer(cart) {
    var itemsEl = document.getElementById("cartItems");
    var footEl = document.getElementById("cartFoot");
    if (!itemsEl) return;

    if (cartCountEl) cartCountEl.textContent = cart.item_count;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-empty">Your bag is empty.<br><br>Start adding some beautiful watches!</div>';
      if (footEl) footEl.style.display = "none";
      return;
    }

    itemsEl.innerHTML = cart.items.map(function (item) {
      return (
        '<div class="cart-item">' +
        (item.image ? '<img src="' + sizedImage(item.image, 160) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : "") +
        '<div class="cart-item-info">' +
        "<h6>" + escapeHtml(item.product_title) + "</h6>" +
        '<div class="qty-row">' +
        '<button class="qty-btn" data-key="' + item.key + '" data-delta="-1" aria-label="Decrease quantity">−</button>' +
        '<span class="qty-val">' + item.quantity + "</span>" +
        '<button class="qty-btn" data-key="' + item.key + '" data-delta="1" aria-label="Increase quantity">+</button>' +
        "</div>" +
        '<button class="remove-btn" data-key="' + item.key + '" data-delta="remove">Remove</button>' +
        "</div>" +
        '<div class="cart-item-price">' + fmtMoney(item.final_line_price) + "</div>" +
        "</div>"
      );
    }).join("");

    if (footEl) footEl.style.display = "block";
    var subtotalEl = document.getElementById("cartSubtotal");
    if (subtotalEl) subtotalEl.textContent = fmtMoney(cart.total_price);

    var comboNote = document.getElementById("cartComboNote");
    if (comboNote) {
      if (cart.item_count >= 2) {
        comboNote.classList.add("show");
        comboNote.textContent = "Combo offer unlocked — your Buy 2 for ₹1599 discount is applied automatically at checkout.";
      } else if (cart.item_count === 1) {
        comboNote.classList.add("show");
        comboNote.textContent = "Add 1 more watch — buy any 2 for ₹1599, applied automatically at checkout.";
      } else {
        comboNote.classList.remove("show");
      }
    }

    itemsEl.querySelectorAll(".qty-btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var key = btn.dataset.key;
        var delta = parseInt(btn.dataset.delta, 10);
        var current = cart.items.find(function (i) { return i.key === key; });
        if (!current) return;
        changeQuantity(key, Math.max(0, current.quantity + delta));
      });
    });
    itemsEl.querySelectorAll(".remove-btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        changeQuantity(btn.dataset.key, 0);
      });
    });
  }

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str || "";
    return div.innerHTML;
  }

  function refreshCartDrawer() {
    fetch(routes.cartJsonUrl)
      .then(function (r) { return r.json(); })
      .then(renderCartDrawer)
      .catch(function () {});
  }

  function changeQuantity(key, quantity) {
    fetch(routes.cartChangeUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
      })
      .catch(function () {});
  }

  function addToCart(variantId, qty, openDrawer) {
    if (!variantId) return Promise.reject("No variant");
    return fetch(routes.cartAddUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) {
            throw new Error((data && data.description) || "add-failed");
          }
          return data;
        });
      })
      .then(function () {
        if (openDrawer === false) {
          showToast("Added to your bag");
          refreshCartDrawer();
        } else {
          openCartDrawer();
        }
        return true;
      })
      .catch(function (err) {
        var msg = err && err.message && err.message !== "add-failed" ? err.message : "Couldn't add to bag — please try again";
        showToast(msg);
        return false;
      });
  }

  document.querySelectorAll(".add-cart-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var variantId = btn.dataset.variantId;
      addToCart(variantId, 1).then(function (ok) {
        if (ok) {
          var original = btn.textContent;
          btn.textContent = "Added ✓";
          btn.classList.add("added");
          setTimeout(function () { btn.textContent = original; btn.classList.remove("added"); }, 1200);
        }
      });
    });
  });

  /* PRODUCT PAGE */
  var pdQtyVal = document.getElementById("pdQtyVal");
  var pdQty = 1;
  var pdQtyMinus = document.getElementById("pdQtyMinus");
  var pdQtyPlus = document.getElementById("pdQtyPlus");
  if (pdQtyMinus && pdQtyPlus) {
    pdQtyMinus.addEventListener("click", function () {
      if (pdQty > 1) { pdQty--; pdQtyVal.textContent = pdQty; }
    });
    pdQtyPlus.addEventListener("click", function () {
      pdQty++; pdQtyVal.textContent = pdQty;
    });
  }
  var pdAddToBag = document.getElementById("pdAddToBag");
  var pdBuyNow = document.getElementById("pdBuyNow");
  if (pdAddToBag) {
    pdAddToBag.addEventListener("click", function () {
      addToCart(pdAddToBag.dataset.variantId, pdQty);
    });
  }
  if (pdBuyNow) {
    pdBuyNow.addEventListener("click", function () {
      pdBuyNow.disabled = true;
      addToCart(pdBuyNow.dataset.variantId, pdQty, false).then(function (ok) {
        if (ok) { window.location.href = "/checkout"; } else { pdBuyNow.disabled = false; }
      });
    });
  }

  /* PRODUCT PAGE IMAGE GALLERY */
  var pdImg = document.getElementById("pdImg");
  var pdThumbs = document.querySelectorAll(".pd-thumb");
  if (pdImg && pdThumbs.length) {
    pdThumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var full = thumb.dataset.full;
        if (full) pdImg.src = full;
        pdThumbs.forEach(function (t) { t.classList.remove("active"); });
        thumb.classList.add("active");
      });
    });
  }

  /* PRODUCT PAGE IMAGE LIGHTBOX (zoom + slider) */
  (function () {
    var galleryDataEl = document.getElementById("pdGalleryData");
    if (!galleryDataEl) return;
    var images = [];
    try { images = JSON.parse(galleryDataEl.textContent); } catch (e) { images = []; }
    if (!images.length) return;

    var lightbox = document.getElementById("pdLightbox");
    var lbImg = document.getElementById("pdLightboxImg");
    var counterEl = document.getElementById("pdLightboxCounter");
    var closeBtn = document.getElementById("pdLightboxClose");
    var prevLbBtn = document.getElementById("pdLightboxPrev");
    var nextLbBtn = document.getElementById("pdLightboxNext");
    if (!lightbox || !lbImg) return;

    var currentIndex = 0;
    var zoomed = false;

    function render() {
      lbImg.src = images[currentIndex];
      if (counterEl) counterEl.textContent = (currentIndex + 1) + " / " + images.length;
      zoomed = false;
      lbImg.classList.remove("zoomed");
      lbImg.style.transformOrigin = "center center";
    }
    function openLightbox(index) {
      currentIndex = index || 0;
      render();
      lightbox.classList.add("open");
      document.body.style.overflow = "hidden";
    }
    function closeLightbox() {
      lightbox.classList.remove("open");
      document.body.style.overflow = "";
    }
    function showPrev() { currentIndex = (currentIndex - 1 + images.length) % images.length; render(); }
    function showNext() { currentIndex = (currentIndex + 1) % images.length; render(); }

    if (pdImg) {
      pdImg.addEventListener("click", function () {
        var activeThumb = document.querySelector(".pd-thumb.active");
        var idx = 0;
        if (activeThumb) {
          var thumbList = Array.prototype.slice.call(pdThumbs);
          var found = thumbList.indexOf(activeThumb);
          if (found > -1) idx = found;
        }
        openLightbox(idx);
      });
    }

    if (closeBtn) closeBtn.addEventListener("click", closeLightbox);
    if (prevLbBtn) prevLbBtn.addEventListener("click", showPrev);
    if (nextLbBtn) nextLbBtn.addEventListener("click", showNext);
    lightbox.addEventListener("click", function (e) {
      if (e.target === lightbox) closeLightbox();
    });
    document.addEventListener("keydown", function (e) {
      if (!lightbox.classList.contains("open")) return;
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowLeft") showPrev();
      if (e.key === "ArrowRight") showNext();
    });
    lbImg.addEventListener("click", function (e) {
      zoomed = !zoomed;
      lbImg.classList.toggle("zoomed", zoomed);
      if (zoomed) {
        var rect = lbImg.getBoundingClientRect();
        var xPct = ((e.clientX - rect.left) / rect.width) * 100;
        var yPct = ((e.clientY - rect.top) / rect.height) * 100;
        lbImg.style.transformOrigin = xPct + "% " + yPct + "%";
      } else {
        lbImg.style.transformOrigin = "center center";
      }
    });
    lbImg.addEventListener("mousemove", function (e) {
      if (!zoomed) return;
      var rect = lbImg.getBoundingClientRect();
      var xPct = ((e.clientX - rect.left) / rect.width) * 100;
      var yPct = ((e.clientY - rect.top) / rect.height) * 100;
      lbImg.style.transformOrigin = xPct + "% " + yPct + "%";
    });
  })();

  /* INITIAL CART COUNT SYNC */
  refreshCartDrawer();
})();